import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { Trans } from 'react-i18next';
import { Card, Text } from '@fragments';
import { IconX } from '@tabler/icons-react';
import TrainedScene from './components/TrainedScene';
import AuthorityScene from './components/AuthorityScene';
import IdentityScene from './components/IdentityScene';
import '../../../../../../components/Scene';
import './styles.scss';

// What the Studio has that a generic AI does not: one card per reason, its animated
// scene on top and the generic AI's answer at the foot.
const REASONS = [
  { key: 'Trained', Scene: TrainedScene },
  { key: 'Authority', Scene: AuthorityScene },
  { key: 'Identity', Scene: IdentityScene },
];

// A scene starts the first time its card scrolls into view, so it opens with its
// entrance and nothing animates unseen. It has no box of its own: it paints on the
// card and fades out at its edges.
function ReasonArt({ Scene, label, t, locale, root }) {
  const host = useRef(null);
  const seen = useInView(host, { root, once: true, amount: 0.2 });
  return <div ref={host} className="studio-landing-reason__art" role="img" aria-label={label}>
    {seen && <div className="studio-feature-art studio-landing-art" aria-hidden="true">
      <div className="studio-feature-art__viewport"><Scene t={t} locale={locale} /></div>
    </div>}
  </div>;
}

export default function Reasons({ t, locale, copy, reveal, root }) {
  return <motion.section className="studio-landing__section" aria-labelledby="studio-landing-why" {...reveal}>
    <header className="studio-landing__heading">
      <Text.span contrast={6}>{t('landingWhyEyebrow')}</Text.span>
      <div className="studio-landing__heading-title">
        <Text.h2 id="studio-landing-why" weight={500} contrast={10}>{t('landingWhyTitle')}</Text.h2>
        <Text.h2 weight={400} contrast={6}>
          <Trans t={t} i18nKey="landingWhyTitleSecond" values={{ who: copy.who }} components={{ who: <em className="studio-landing__vivid" /> }} />
        </Text.h2>
      </div>
      <Text.p contrast={7}>{t('landingWhyText', copy)}</Text.p>
    </header>
    <div className="studio-landing-reasons">
      {REASONS.map(({ key, Scene }) => <Card key={key} className="studio-landing-reason" noBodyPadding
        footer={<Text.caption contrast={5} left={<IconX />}>{t(`landing${key}Vs`)}</Text.caption>}>
        <ReasonArt Scene={Scene} label={t(`landing${key}Art`, copy)} t={t} locale={locale} root={root} />
        <div className="studio-landing-reason__copy">
          <Text.h5 weight={500} contrast={9}>{t(`landing${key}Title`)}</Text.h5>
          <Text.p contrast={7}>{t(`landing${key}Text`, copy)}</Text.p>
        </div>
      </Card>)}
    </div>
  </motion.section>;
}
